
import React from 'react'
import { Link } from 'react-router-dom'

interface StoreSplitV2Props {
  currentLang: 'zh' | 'en'
}

interface StoreCard {
  title: string
  image: string
  href: string
  cta: string
  width: 'wide' | 'narrow'
}

const StoreSplitV2: React.FC<StoreSplitV2Props> = ({ currentLang }) => {
  const stores: StoreCard[] = [
    {
      title: 'ONGU Studio Xinyi',
      image: 'https://file.lumi.new/p373839333138763776/SPF2016978764204675072.webp',
      href: `/${currentLang}/store/xinyi`,
      cta: 'Read more',
      width: 'wide',
    },
    {
      title: 'Branch Coffee Roasters',
      image: 'https://file.lumi.new/p373839333138763776/SPF2016963105768935424.webp',
      href: `/${currentLang}/store`,
      cta: 'Read more',
      width: 'narrow',
    },
  ]

  return (
    <section className="bg-[#FAF9F1] pb-2">
      {/* Asymmetric 60/40 split — signature baristamap layout */}
      <div className="flex w-full flex-col gap-2 md:flex-row">
        {stores.map((store) => (
          <Link
            key={store.title}
            to={store.href}
            className={`group relative block h-[215px] overflow-hidden ${
              store.width === 'wide' ? 'md:w-[60%]' : 'md:w-[40%]'
            }`}
          >
            {/* Background image */}
            <img
              src={store.image}
              alt={store.title}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/35 transition-colors duration-300 group-hover:bg-black/45" />

            {/* Content centered */}
            <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
              <h3
                className="mb-6 text-white"
                style={{
                  fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                  fontWeight: 400,
                  fontSize: 'clamp(1.25rem, 2.2vw, 1.75rem)',
                  letterSpacing: '0.06em',
                }}
              >
                {store.title}
              </h3>
              <span
                className="border-b border-white/80 pb-1 text-xs tracking-[0.2em] text-white"
                style={{ fontFamily: "'EB Garamond', serif" }}
              >
                {store.cta}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  )
}

export default StoreSplitV2
